export default function useSanitizeString(string: string) {
    return string.replace(/[^a-z0-9áéíóúñü \.,_-]/gim,"").trim();
}

export {
    useSanitizeString
}
